<template>
  <div style="margin-top: 1.5rem;">
    <h1 class="title is-size-4">Last step:</h1>
    <p class="subtitle">Please finish by paying with PayPal below.</p>
    <paypal-button :loading="paypalButtonLoading" :html="paypalButtonHtml" />
  </div>
</template>

<script>
import PaypalButton from '@/components/PaypalButton.vue'
import tournamentRetriever from '@/mixins/tournamentRetriever.js'

export default {
  name: "TournamentSignupPay",
  mixins: [tournamentRetriever],
  components: {
    PaypalButton
  },
  data() {
    return {
      paypalButtonLoading: true,
      paypalButtonHtml: ""
    }
  },
  created() {
		let registrationType = this.tournament.individualRegistration ? 'individual' : 'team';
		let id = this.$route.params.registrationId;
    let promise = this.axios.get(`${this.$apiRoot}/paypal/tournament/${id}/?registration_type=${registrationType}`);
    promise.then(response => {
      this.paypalButtonHtml = response.data.paypalHtml;
      this.paypalButtonLoading = false;
    });
  }
}
</script>